module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats"
  }, [_c('div', {
    staticClass: "stats__line stats__line--feedback"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.share('twitter')
      }
    }
  }, [_vm._v("Share on Twitter")])]), _vm._v(" "), _c('div', {
    staticClass: "stats__line stats__line--total"
  }, [_vm._v("\n    " + _vm._s(_vm._f("number")((_vm.globalPoints || '20,000,000+'))) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "stats__line stats__line--points"
  }, [_vm._v("\n    " + _vm._s(_vm._f("number")(_vm.points)) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7fcd9192!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Stats.vue
// module id = 167
// module chunks = 2